// Maximum search items to save to history
export const HISTORY_ITEM_LIMIT = 12

// Search Mode
export enum SearchMode {
  Location = 'location',
  Landowner = 'landowner',
}

// Pseudo route name for managing back navigation from search result card to search results list
export const SEARCH_BACK_ROUTE = '/search'
